import { ContainerDetailsState } from '../reducers/container-details.reducer';
import { FormContainer, FormDocument } from '@eBeihilfe/einreichung-shared/model';
import { Injectable, Signal, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { containerDetailsActions } from '../actions';
import {
  selectContainerDetailsData,
  selectContainerDetailsError,
  selectContainerDetailsLoading,
  selectFormById,
  selectMandatoryDocuments,
  selectNotMandatoryDocuments,
} from '../selectors';

@Injectable()
export class ContainerDetailsFacade {
  private readonly store: Store<ContainerDetailsState> = inject(Store);

  public loadData(containerId: string | null): void {
    if (containerId !== null) {
      this.store.dispatch(containerDetailsActions.load({ containerId }));
    }
  }

  public selectData(): Signal<FormContainer> {
    return this.store.selectSignal(selectContainerDetailsData);
  }

  public selectFormById$(): Observable<FormDocument | null> {
    return this.store.select(selectFormById);
  }

  public selectFormById(): Signal<FormDocument | null> {
    return this.store.selectSignal(selectFormById);
  }

  public selectLoading(): Signal<boolean> {
    return this.store.selectSignal(selectContainerDetailsLoading);
  }

  public selectError(): Signal<boolean> {
    return this.store.selectSignal(selectContainerDetailsError);
  }

  public selectError$(): Observable<{ message: string; type: ReturnType<typeof containerDetailsActions.loadFailed> }> {
    return this.store.select(selectContainerDetailsError);
  }

  public selectMandatoryForms(): Signal<FormDocument[]> {
    return this.store.selectSignal(selectMandatoryDocuments);
  }

  public selectMandatoryForms$(): Observable<FormDocument[]> {
    return this.store.select(selectMandatoryDocuments);
  }

  public selectNotMandatoryForms(): Signal<FormDocument[]> {
    return this.store.selectSignal(selectNotMandatoryDocuments);
  }

  public selectNotMandatoryForms$(): Observable<FormDocument[]> {
    return this.store.select(selectNotMandatoryDocuments);
  }

  public clearStore(): void {
    this.store.dispatch(containerDetailsActions.clearStore());
  }
}
